type RevealTargetListener = () => void;

let revealTargetEl: HTMLElement | null = null;
let inert = false;
let loadedTransactionId: string | null = null;
let retainedParamsKey: string | null = null;
let retainedAt: number | null = null;
let contentHeight: number | null = null;
const listeners = new Set<RevealTargetListener>();

export const checkoutRevealStore = {
  setRevealTarget(el: HTMLElement | null): void {
    revealTargetEl = el;
    listeners.forEach((listener) => listener());
  },

  getRevealTarget(): HTMLElement | null {
    return revealTargetEl;
  },

  setInert(value: boolean): void {
    inert = value;
  },

  getInert(): boolean {
    return inert;
  },

  getLoadedTransactionId(): string | null {
    return loadedTransactionId;
  },

  setLoadedTransactionId(transactionId: string | null): void {
    loadedTransactionId = transactionId;
    if (!transactionId && contentHeight !== null) {
      retainedParamsKey = null;
      retainedAt = null;
      contentHeight = null;
      listeners.forEach((listener) => listener());
    }
  },

  clearLoadedTransactionId(transactionId?: string): void {
    if (transactionId && loadedTransactionId !== transactionId) {
      return;
    }

    loadedTransactionId = null;
    retainedParamsKey = null;
    retainedAt = null;
    const hadContentHeight = contentHeight !== null;
    contentHeight = null;
    if (hadContentHeight) {
      listeners.forEach((listener) => listener());
    }
  },

  setContentHeight(height: number): void {
    if (contentHeight === height) return;
    contentHeight = height;
    listeners.forEach((listener) => listener());
  },

  getContentHeight(): number | null {
    return contentHeight;
  },

  markRetained(paramsKey: string): void {
    retainedParamsKey = paramsKey;
    retainedAt = Date.now();
  },

  getRetainedTransactionId(paramsKey: string, ttlMs: number): string | null {
    if (
      !loadedTransactionId ||
      retainedParamsKey !== paramsKey ||
      retainedAt === null ||
      Date.now() - retainedAt >= ttlMs
    ) {
      return null;
    }

    return loadedTransactionId;
  },

  subscribe(listener: RevealTargetListener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
